export default {
	job_positions_index: ({ job_positions_index }) => {
		return job_positions_index;
	},
};
